import api from '@/api/api';

export const dashboardService = {
  getResultDashboard
};

function getResultDashboard(Acao, IdResponsavel) {
  let query = IdResponsavel ? `?Acao=${Acao}&IdResponsavel=${IdResponsavel}` : `?Acao=${Acao}`;
  return api.get(`dashboard${query}`);
}